import { render, staticRenderFns } from "./IconProofreadDone.vue?vue&type=template&id=4870bfb4&"
import script from "./IconProofreadDone.vue?vue&type=script&lang=js&"
export * from "./IconProofreadDone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4870bfb4')) {
      api.createRecord('4870bfb4', component.options)
    } else {
      api.reload('4870bfb4', component.options)
    }
    module.hot.accept("./IconProofreadDone.vue?vue&type=template&id=4870bfb4&", function () {
      api.rerender('4870bfb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconProofreadDone.vue"
export default component.exports